module.exports = __webpack_public_path__ + "img/1.b0dd0ca0.jpg";